module.exports = __webpack_public_path__ + "static/media/HCMM684.c99e91f2.jpg";